const routes = {
  tenants: () => '/system-configuration/tenants',
  tenantsItem: (id) => `/system-configuration/tenants/${id}`
};

export default routes;
